import { Component, Inject, OnInit } from '@angular/core';
import {
    AddressModel,
    ClientManagerInstanceToken,
    ClientManagerInterface,
    NotificationModel,
    WindowService,
} from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { faEnvelope, faMapMarker } from '@fortawesome/free-solid-svg-icons';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-customer',
    templateUrl: './customer.component.html',
    styleUrls: ['./customer.component.scss'],
    standalone: false,
})
export class CustomerComponent implements OnInit {
    public notification: NotificationModel;
    private readonly window: Window;

    public faEnvelope = faEnvelope;
    public faMapMarker = faMapMarker;
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        public readonly modalInstance: BsModalRef,
        private readonly windowService: WindowService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {
        this.window = this.windowService.nativeWindow;
    }

    public ngOnInit(): void {
        const selectedState = this.notification.address.statesOfUSA?.selectedEntry?.model?.value ?? '';
        AddressModel.updateStateOfUSA(this.notification.address, selectedState);
    }

    public showMap(): void {
        const address = this.notification.address;

        const navigationAddress = `${address.street.value}+${address.postCode.value}+${address.city.value}`;
        const newWindow = window.open(`https://www.google.com/maps?dirflg=d&daddr=${navigationAddress}`, '_blank');
        if (newWindow) {
            newWindow.opener = null;
        }
    }

    public openEmail(emailAddress: string): void {
        if (emailAddress.indexOf('@') > 0) {
            this.window.location.href = `mailto:${emailAddress}`;
        }
    }
}
